<template>
  <div id="Profile" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 fixed-t">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">F</span>erfil</div>
        <div class="col-3 t-r f26"></div>
    </div>
    <div class="h4"></div>
    <div class="col-12 mt8">
      <div class="col-12 bg-color-white f14 pl8 pr8">
        <div class="col-12 lh50 bb1">
          <div class="col-4 t-l color-muted">Usuario</div>
          <div class="col-8 t-r color-muted">{{ pageData.user }}</div>
        </div>
        <div class="col-12 lh50 bb1">
          <div class="col-4 t-l color-muted">Nombre</div>
          <div class="col-8 t-r"><input type="text" name="" v-model="pageData.name" class="t-r"></div>
        </div>
        <div class="col-12 lh50 bb1">
          <div class="col-4 t-l color-muted">Teléfono</div>
          <div class="col-8 t-r"><input type="text" name="" v-model="pageData.tel" class="t-r"></div>
        </div>
        <div class="col-12 lh50 bb1">
          <div class="col-4 t-l color-muted">Correo</div>
          <div class="col-8 t-r"><input type="text" name="" v-model="pageData.email" class="t-r"></div>
        </div>
      </div>
      <div class="col-12 mb10 mt10 pl20 pr20">
        <button class="bg-color-primary color-white w-100 lh40 r5" @click="save()">Guardar</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Profile',
  data () {
    return {
      pageData: {}
    }
  },
  created: function () {
    this.get_pageData();
  },
  methods: {
    save: function () {
      let post_data = {}
      post_data.name = this.pageData.name;
      post_data.tel = this.pageData.tel;
      post_data.email = this.pageData.email;
      let _this = this;
      this.post(this.api_url + 'manage/account_update',post_data,true).then((res)=>{
        if(res.status == 1){
          _this.post(this.api_url + 'manage/account','',true).then((res)=>{
            _this.$store.commit('setAccount',res.data);
          });
          this.$store.commit('setAlert',{type:'success',msg: "Success"});
          this.get_pageData();
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      });
    },
    get_pageData: function () {
      this.post(this.api_url + 'manage/account_data','',true).then((res)=>{
        if(res.status == 1){
          this.pageData = res.data;
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      });
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Main/Profile.vue